import { gsap } from 'gsap'
import { ScrollTrigger } from 'gsap/ScrollTrigger'

gsap.registerPlugin(ScrollTrigger)

document.querySelectorAll('.element-timeline').forEach((el) => {
  const items = el.querySelectorAll('.timeline-wrapper')

  gsap.set(el.querySelectorAll('.timeline-marker'), { scale: 0 })
  gsap.set(el.querySelectorAll('.timeline-line'), { scaleY: 0 })
  gsap.set(el.querySelectorAll('.odd .timeline-image'), { opacity: 0, x: '-100vw' })
  gsap.set(el.querySelectorAll('.even .timeline-image'), { opacity: 0, x: '100vw' })
  gsap.set(el.querySelectorAll('.odd .timeline-content'), { opacity: 0, x: '100vw' })
  gsap.set(el.querySelectorAll('.even .timeline-content'), { opacity: 0, x: '-100vw' })

  items.forEach((item) => {
    const timeline = gsap.timeline({
      paused: true,
      scrollTrigger: {
        trigger: item,
        start: 'top 60%',
        markers: false,
      },
    })

    timeline.to(item.querySelector('.timeline-line'), {
      scaleY: 1,
      duration: 0.2,
      ease: 'power4',
    })

    timeline.to(item.querySelector('.timeline-marker'), {
      scale: 1,
      duration: 0.4,
      ease: 'power4',
    })

    timeline.to(
      item.querySelector('.timeline-image'),
      {
        x: 0,
        opacity: 1,
        duration: 0.6,
        ease: 'ease',
      },
      '<25%'
    )

    timeline.to(
      item.querySelector('.timeline-content'),
      {
        x: 0,
        opacity: 1,
        duration: 0.6,
        ease: 'ease',
        delay: 0.2,
      },
      '<'
    )
  })
})
